import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchSupplier } from "../features/supplier/supplierSlice";

import SupplierForm from "./SupplierForm";
import SupplierTable from "./SupplierTable";

function Supplier() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.supplier
    );

    useEffect(() => {

        dispatch(fetchSupplier());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <SupplierForm />

                </div>

                <div className="col-lg-8">

                    <SupplierTable />

                </div>

            </div>

        </div>

    );

}

export default Supplier;